// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA5qRfnhAbZJiUoxeUkKv3gjZaL0ffTFl8",
  authDomain: "medicino-patient.firebaseapp.com",
  projectId: "medicino-patient",
  storageBucket: "medicino-patient.appspot.com",
  messagingSenderId: "294740444356",
  appId: "1:294740444356:web:1d386e328167d6d4b87591"
};

// // init firebase
// initializeApp(firebaseConfig)

// // init firestore service
// const db = getFirestore()
// export default db

// Initialize Firebase
firebase.initializeApp(firebaseConfig);


// Initialize Cloud Firestore and get a reference to the service
const db = firebase.firestore();
export default db;
